import { InjectionToken } from "@angular/core";
import { SvgIconInfo, SVG_ICONS } from "@core/icons";

export const SvgSidNavIconsProviders: Array<{
  provide: InjectionToken<SvgIconInfo[]>;
  useValue: SvgIconInfo;
  multi: boolean;
}> = [];
